<div class="inner-container product-list mt-3">
  @if (loading()) {
    <div class="flex justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" />
    </div>
  } @else {
    @if (error()) {
      <app-empty-page [message]="'There was an error loading the kit. Please try again later.'" />
    } @else {
      <div class="banner">
        <img [src]="kit()?.banner?.full_path" alt="" />
      </div>
      <div class="product-info">
        <div class="flex justify-content-between align-items-center">
          <h2 class="m-0">
            @if (kit()?.amount === 1) {
              {{ 'KIT.numberOfProductsSingular' | translate: { number: kit()?.amount } }}
            } @else {
              {{ 'KIT.numberOfProducts' | translate: { number: kit()?.amount } }}
            }
          </h2>
          <div class="flex gap-3">
            @if (!overLimit()) {
              <app-button
                label="{{ 'KIT.continueToShipping' | translate }}"
                buttonClassName="no-fixed-height kit-continue-to-shipping"
                (click)="router.navigate(['/checkout'])"
              ></app-button>
            }
          </div>
        </div>
        <div class="selected-products pt-3">
          @if (cartItemsLength() > 0) {
            @for (product of cartItems(); let i = $index; track i) {
              <div class="product-slot">
                <img [src]="product.image" [alt]="product.name" />
                <a
                  href="#"
                  class="remove-item-icon"
                  (click)="$event.preventDefault(); removeProduct(product.index)"
                >
                  <div>
                    <img src="assets/img/icons/times-icon.svg" alt="Close" />
                  </div>
                </a>
              </div>
            }
          }
          @for (slot of remainingSlots(); let i = $index; track i) {
            <div class="empty-slot"></div>
          }
        </div>
        <p class="mb-0" style="color: #ffffff">
          Select your favorite items below and follow the prompts to enter your shipping details.
          Your personalized gifting package is on its way - We can't wait for you to receive it!
        </p>
      </div>
      @if (overLimit()) {
        <div class="store-status-banner-gifting">
          {{ 'KIT.overTheLimit' | translate: { max: maxProductAllowed(), remove: overLimit() } }}
        </div>
      }
      @if (maxQuantForSelection() !== undefined && Number(maxQuantForSelection()) <= 0) {
        <div class="store-status-banner-gifting mt-2">
          {{
            'KIT.maxQuantOfProductAdded'
              | translate: { max: maxProductAllowed(), remove: overLimit() }
          }}
        </div>
      }
      <div class="kit-product-list">
        <div class="site-container">
          @if (listView()) {
            @if (requiredProducts().length) {
              <h3 class="text-center" style="font-weight: 400">Required Products</h3>
              <div class="flex justify-content-center align-items-center">
                @for (product of requiredProducts(); track product.id) {
                  <div class="product-item" style="flex-basis: 25%">
                    <a
                      href="#"
                      (click)="$event.preventDefault(); openModal(product)"
                      style="text-decoration: none; cursor: pointer"
                    >
                      <app-product-item
                        [product]="product"
                        [noLink]="true"
                        [hidePrice]="cartStore.hideProductPrices()"
                        [cartIcon]="true"
                        (cartClick)="openModal(product)"
                      ></app-product-item>
                    </a>
                  </div>
                }
              </div>
              <p-divider />
            }
            <div
              class="product-grid"
              [ngStyle]="{
                'grid-template-columns': 'repeat(' + 4 + ', 1fr)'
              }"
            >
              @for (product of nonRequiredProducts(); track product.id) {
                <div class="product-item">
                  <a
                    href="#"
                    (click)="$event.preventDefault(); openModal(product)"
                    style="text-decoration: none; cursor: pointer"
                  >
                    <app-product-item
                      [product]="product"
                      [noLink]="true"
                      [hidePrice]="cartStore.hideProductPrices()"
                      [cartIcon]="true"
                      (cartClick)="openModal(product)"
                    ></app-product-item>
                  </a>
                </div>
              }
            </div>
          } @else {
            <div class="mb-2">
              <app-button
                label="{{ 'KIT.backToList' | translate }}"
                [buttonStyle]="'outlined'"
                (click)="listView.set(true); modalProduct.set(undefined)"
              ></app-button>
            </div>
            <app-product
              [productSlugInput]="modalProduct()?.slug"
              [maxQuantForSelection]="maxQuantForSelection()"
              (itemAddedCallback)="onItemAdded()"
            />
          }
        </div>
      </div>
    }
  }
</div>
<p-dialog
  header="You cant leave this page untill you add all the required products"
  [(visible)]="leavingDialog"
  [modal]="true"
  [style]="{ width: '400px' }"
></p-dialog>
